import { apiRequest } from './apiService';

// Fetch all subscriptions
export const fetchSubscriptions = async () => {
  return await apiRequest('sales/sales-subscriptions', 'GET');
};

// Fetch a single subscription by ID
export const fetchSubscriptionById = async (subscriptionId: string) => {
  return await apiRequest(`sales/sales-subscriptions/${subscriptionId}`, 'GET');
};

// Create a new subscription
export const createSubscription = async (formData: any) => {
  return await apiRequest('sales/sales-subscriptions', 'POST', formData);
};

// Update an existing subscription
export const updateSubscription = async (
  subscriptionId: string,
  formData: any
) => {
  return await apiRequest(
    `sales/sales-subscriptions/${subscriptionId}`,
    'PUT',
    formData
  );
};

// Delete a subscription (soft delete by updating CDC_FLAG)
export const deleteSubscription = async (subscriptionId: string) => {
  return await apiRequest(
    `sales/sales-subscriptions/${subscriptionId}`,
    'DELETE'
  );
};

// Fetch all sales institutes (Dropdown data)
export const fetchInstitutes = async (id: any) => {
  return await apiRequest(`sales/sales-institutes/${id}`, 'GET');
};

// Fetch all services (Dropdown data)
export const fetchServices = async () => {
  return await apiRequest('sales/sales-services', 'GET');
};

// Fetch all plans (Dropdown data)
export const fetchPlans = async () => {
  return await apiRequest('sales/sales-plans', 'GET');
};
